// extracted by mini-css-extract-plugin
module.exports = {"row":"OffertDetailsButtonsContent_row__tEk1D"};